import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

export const Error: FC = () => (
    <FormattedMessage id="shared.error" defaultMessage="An error occurred." />
);
